import { useMutation } from 'react-query';

import { saveProjectOutputConfigurations } from 'shared/api/projects/http';

const useMutateSaveProjectOutputConfigurations = (options = undefined) =>
  useMutation(({ id, configurations }) => saveProjectOutputConfigurations(id, configurations), options);

export default useMutateSaveProjectOutputConfigurations;
